import { DistributionsApi } from "../../../services/api/distributions";

export const Distribute = async (
  token,
  sets, // array of rel_ids (strings/numbers)
  subject,
  message, // string, also called body
  emails, //array
  schedule = 0 // optional, unix
) => {
  let err = [];

  let tkn;
  try {
    tkn = await token();
  } catch (error) {
    return { success: false, message: [`Token retrieval failed: ${error.message}`] };
  }

  // check if there are empty variables
  if (sets.length === 0) err.push("Set array is empty");
  if (subject === "") err.push("Subject is empty");
  if (emails.length === 0) err.push("No email/s given");

  if (err.length > 0) return { success: false, message: err, stage: "1" };

  if (schedule === 0) schedule = Math.round(new Date().getTime() / 1000); // set time as now if schedule is unsepcified

  const body = {
    subject: subject,
    message: message, // Changed from 'body' to 'message' to match backend expectation
    collections: sets, // Now expects array of rel_ids, not objects
    emails: emails,
    time: schedule,
  };

  try {
    const response = await DistributionsApi.addDistribution(tkn, body);
    if (!response.success) {
      err.push(response.message || "Something went wrong");
    }
  } catch (error) {
    err.push("Async failure: " + error.message);
  }

  if (err.length === 0) return { success: true, message: "" };
  else return { success: false, message: err };
};
